<template>
  <div>
    <CustomHeader :title="title" />
    <div v-if="showInsightsPanel" class="insights-panel">
      <span @click="closeInsightsPanel" class="close-button">X</span>
      <img src="i-SET.png" alt="Logo" style="width: 180px; margin-right: 10px" />
      <p style="font-weight: bold; font-size: 18px; margin-top: 30px">Insights</p>

      <div class="sub-panel">
        <p class="sub-panel-title">Atrações Turísticas</p>
        <div class="info-container">
          <img src="lamp-icon.png" alt="Some Image" class="info-image" style="width: 20px" />
          <span class="info-text">2 Insights</span>
        </div>
        <div class="button-container">
          <button class="open-button" @click="openContainers">Abrir</button>
        </div>

        <div class="containers" :class="{ visible: isOpen }">
          <img
            src="i-SET.png"
            alt="Logo"
            style="width: 180px; margin-right: 10px; margin-left: 30px"
          />
          <h2 style="font-size: 24px; margin-top: 30px; font-weight: bold; margin-left: 30px">
            Análise do SET
          </h2>
          <button class="close-button" @click="closeContainer">X</button>
          <p style="font-size: 18px; margin-top: 30px; margin-left: 30px">TESTES</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomHeader from './CustomHeader/CustomHeader.vue'
import Layout from './Layout'
import Map from './Map.vue'
import EconomicPerformance from './EconomicPerformance/EconomicPerformance.vue'
import Profile from './Profile/Profile.vue'

export default {
  name: 'transport-modes',
  layout: Layout,
  components: {
    Map,
    EconomicPerformance,
    Profile,
    CustomHeader,
  },
  data() {
    return {
      currentView: 'map',
      showInsightsPanel: false,
      showInsightsPanel: false,
      selectedButton: null,
      isOpen: false,
      title: 'Perfil do Visitante',
    }
  },
  methods: {
    changeView(view) {
      this.currentView = view
    },
    toggleInsightsPanel() {
      this.showInsightsPanel = !this.showInsightsPanel
    },
    closeInsightsPanel() {
      this.showInsightsPanel = false
    },
    openContainers() {
      this.isOpen = !this.isOpen
    },
    closeContainer() {
      this.isOpen = false
    },
  },
}
</script>

<style scoped>
.abcc {
  display: flex;
  border: 2px solid red;
  width: 100%;
  height: 100%;
}
.content {
  float: left;
  width: 70%;
}

.side-panel {
  background-color: white;
  color: gray;
  padding: 20px;
  border-radius: 10px;
  width: 250px;
  position: absolute;
  top: 100px;
  left: 20px;
  width: 300px;
  height: 1400px;
  margin-bottom: 25px;
}

.menu button {
  margin-bottom: 40px;
}
.word-panel {
  position: absolute;
  top: 130px;
  right: 20px;
  display: flex;
  background-color: #e6e3e3;
  padding: 10px;
  border-radius: 10px;
}
.insights-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9998;
}

.insights-panel {
  position: fixed;
  bottom: 0;
  right: 0;
  height: 100vh;
  width: 450px;
  background-color: #ffffff;
  color: rgb(52, 48, 48);
  padding: 10px;
  z-index: 9999;
}

.insights-bar {
  position: fixed;
  display: flex;
  bottom: 0;
  right: 0;
  background-color: #1e2c4e;
  color: white;
  padding: 10px 10px;
  border-radius: 15px;
  cursor: pointer;
  z-index: 9999;
  width: 450px;
  height: 60px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
.sub-panel-title {
  font-weight: bold;
  color: #333;
}
.open-button {
  background-color: #50acba;
  color: white;
  border: none;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 8px;
}
.sub-panel {
  background-color: #f7f3f3;
  padding: 15px;
  border-radius: 10px;
  margin-top: 20px;
}
.button-container {
  text-align: right;
  margin-top: -40px;
}
.info-text {
  margin-left: 15px;
  font-size: 14px;
  color: #50acba;
}
.info-container {
  display: flex;
  align-items: center;
}
.containers {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 600px;
  background-color: #fff;
  transition: transform 0.3s ease-in-out;
  transform: translateY(100%);
}

.visible {
  transform: translateY(0%);
}
.flex-container {
  padding-bottom: 50px;
}
</style>
